import { Link } from "react-router-dom";

/* eslint-disable */
function Footer() {
  return (
    <footer
      style={{
        backgroundColor: "#ceffb8",
        color: "#000000",
        fontFamily: "Jost, sans-serif",
        padding: "20px 20px",
        position: "relative",
      }}
    >
      <div className="mt-5" style={{ maxWidth: "1300px", margin: "0 auto" }}>
        {/* IMFRA Title */}
        <div style={{ textAlign: "left" }}>
          <h1
            style={{
              fontSize: "36px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            IMFRA
          </h1>

          {/* Navigation Links */}
          <div style={{ fontSize: "20px", fontWeight: "400", lineHeight: "2" }}>
            <p>
              <Link className="nav-link nav-text" to="aboutUs">
                About Us
              </Link>
            </p>
            <p>
              <Link className="nav-link nav-text" to="gallery">
                Gallery
              </Link>
            </p>
            <p>
              <Link className="nav-link nav-text" to="events">
                Events
              </Link>
            </p>
            <p
              style={{ fontSize: "16px", fontWeight: "300", marginTop: "10px" }}
            >
              +49 123 456 789
            </p>
          </div>
        </div>

        {/* Social Icons */}
        <div
          style={{
            marginTop: "20px",
            fontSize: "24px",
            display: "flex",
            justifyContent: "flex-start",
            gap: "20px",
          }}
        >
          <a href="#" style={{ color: "#000000" }}>
            <a
              href="https://www.instagram.com/imfra.hessen.de?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#000000" }}
            >
              <i className="bi bi-instagram"></i>
            </a>
          </a>
          <a href="#" style={{ color: "#000000" }}>
            <a
              href="https://www.facebook.com/share/g/18jRAZQYeL/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#000000" }}
            >
              <i className="bi bi-facebook"></i>
            </a>
          </a>
          <a href="#" style={{ color: "#000000" }}>
            <i className="bi bi-envelope"></i>
          </a>
        </div>
      </div>

      {/* Footer Note */}
      <div
        style={{
          textAlign: "center",
          marginTop: "30px",
          fontSize: "14px",
          fontWeight: "300",
        }}
      >
        © IMFRA. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
